'use strict';

bbw.directive.bbwAuthUserAvatar = ['bbw.AuthUserAvatarSvc', function(authUserAvatarSvc) {
    return {
        restrict: 'A',
        template: '<span bbw-photo-src="avatar.url"></span>',
        scope: true,
        link: function(scope, element, attrs) {
            var size = attrs.bbwAuthUserAvatar || '';
            authUserAvatarSvc.wireScope(scope, 'avatar', size);
        }
    };
}];
